/* Supplemental interactions only. Native Shopify owns commerce and revenue. */
(() => {
  if (window.swMeasurementStarted) return;
  const config = document.getElementById('sw-measurement');
  if (!config) return;
  window.swMeasurementStarted = true;

  function publish(name, details) {
    try {
      const shopify = window.Shopify;
      // Unknown/denied consent fails closed; never store or replay past clicks.
      if (shopify?.customerPrivacy?.analyticsProcessingAllowed() !== true ||
          typeof shopify.analytics?.publish !== 'function') return;
      const data = config.dataset;
      const pageTypes = ['index', 'product', 'collection', 'cart', 'search', 'page', 'blog', 'article'];
      const payload = {
        schema_version: 1,
        language: /^ar(?:-|$)/i.test(data.locale) ? 'ar' : /^en(?:-|$)/i.test(data.locale) ? 'en' : 'other',
        viewport: window.matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop',
        page_type: pageTypes.includes(data.pageType) ? data.pageType : 'other',
        ...details
      };
      if (/^\d{1,20}$/.test(data.productId || '')) payload.product_id = data.productId;
      shopify.analytics.publish(name, payload);
    } catch (_) {
      // Measurement may never interfere with navigation or comparison.
    }
  }

  function isStoreContact(link) {
    try {
      const url = new URL(link.href);
      return url.protocol === 'https:' && (
        (url.hostname === 'wa.me' && url.pathname.replace(/\/$/, '') === '/97317404590') ||
        (url.hostname === 'api.whatsapp.com' && url.pathname === '/send' && url.searchParams.get('phone') === '97317404590')
      );
    } catch (_) { return false; }
  }

  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0) return;
    const target = event.target;
    if (!target?.closest) return;
    const link = target.closest('a[href]');
    if (link && isStoreContact(link)) {
      const placements = ['header', 'footer', 'product', 'collection', 'guide', 'floating'];
      const placement = link.dataset.swContactPlacement;
      publish('switchon:whatsapp_clicked', {
        placement: placements.includes(placement) ? placement : 'other',
        interaction_type: 'assisted_contact_intent'
      });
    }
  });

  // Emitted by the compare module after showModal succeeds. Product IDs come
  // from its selection state, which survives AJAX collection/filter changes.
  document.addEventListener('switchon:comparison-opened', event => {
    const dialog = document.querySelector('#swc-comparison dialog');
    const raw = event.detail?.productIds;
    if (!dialog?.open || !Array.isArray(raw) || raw.length > 3) return;
    const ids = [...new Set(raw.map(String))];
    if (ids.length < 2 || ids.some(id => !/^\d{1,20}$/.test(id))) return;
    publish('switchon:compare_viewed', { product_ids: ids, product_count: ids.length });
  });

  // Uses Shopify's supported loader; it does not grant or change consent.
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
    } catch (_) { /* Continue without measurement if privacy API is unavailable. */ }
  }
})();
